import React, { useEffect, useState } from 'react';
import uploadPhotos from "@/images/Company-logo.svg";
import { map, size, truncate } from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';


function NewsBlog({ newsData }) {

  const [data, setData] = useState([]);

  useEffect(() => {
    if (newsData) {
      setData(newsData);
    }
  }, [newsData]);


  const styles = {
    listPad: {
      display: 'flex',
      gap: '16px',
      alignItems: 'flex-start',
      lineHeight: '1.5',
      borderBottom: '1px solid #dedede',
      paddingBottom: '3px',
      marginBottom: '5px',
    },
    thumb: {
      width: '70px',
      height: '70px',
      flexShrink: 0,
      borderRadius: '8px',
      overflow: 'hidden',
      border: '1px solid #ccc',
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    detail: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      fontSize: '14px',
      fontWeight: 600,
      color: '#333',
      textDecoration: 'none',
    },
    description: {
      fontSize: '12px',
      color: '#555',
    },
    date: {
      fontSize: '12px',
    },
    button: {
      alignSelf: 'flex-start',
      padding: '6px 12px',
      fontSize: '12px',
      backgroundColor: '#0b4471',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out',
    },
  };

  return (<>
    <div className="head underline">
      <h3>Latest News</h3>
    </div>
    <div class="company-list-wrape news-list-wrape">
      {data?.length > 0 ?
        map(data, (news, index) => {
          let truncatedContent = news?.description;
          if (size(news?.description) > 45) {
            truncatedContent = truncate(news?.description, {
              'length': 45,
              'omission': "..."
            });
          }
          return (
            <div  key={index}>
              {/* style={styles.listPad} */}
              <div className='company-list-pad'>
                <div className='company-thumb'>
                  {/* style={styles.thumb}  */}
                  {news.image_url != null ? (
                    <img
                      src={news.image_url}
                      alt={`${news.title}`}
                      // style={styles.img}
                    />
                  ) : (
                    <img
                      src={uploadPhotos}
                      alt="Not Found"
                      // style={styles.img}
                    />
                  )}
                </div>
                <div  className='company-detail'>
                  {/* style={styles.detail} */}
                  {/* <Link to={''} target="_blank" style={styles.title}>
                        <b>{member.title ?? '-'}</b>
                      </Link> */}
                  <Link href={`${news.link}`} target="_blank" to={`${news.link}`}  >
                    {/* style={styles.title} */}
                    <b>{news.title ?? '-'}</b>
                  </Link>
                  <div className='other-detail'>
                    <p className='left-text'>
                      {/* style={styles.date} */}
                      {moment(news.pubDate).format("DD MMM YYYY")}
                    </p>
                    <p dangerouslySetInnerHTML={{ __html: truncatedContent }}>
                      {/* style={styles.description} */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        }) : (
          <div className="card-body">
            <b>No Data Found</b>
          </div>
        )}
    </div>
  </>)
}

export default NewsBlog
